/**
 * Avery Label Templates
 * 
 * All dimensions in millimeters.
 * 
 * Sources:
 * 1 inch = 25.4 mm
 * Letter page = 215.9mm x 279.4mm
 */

export const LabelTemplates = {
  // Avery 18294 - Return Address Labels
  // 4 columns x 15 rows = 60 labels
  '18294': {
    name: 'Avery 18294 (Return Address)',
    description: '60 labels per sheet (4 cols x 15 rows)',
    page: {
      width: 215.9, // 8.5"
      height: 279.4, // 11"
    },
    layout: {
      rows: 15,
      cols: 4,
    },
    dimensions: {
      // Tuned Iteration 3:
      // User Confirmed: "Leftmost values are correct" -> Pitch is correct at 55.333.
      // Width: "Increase by 2" -> 44 + 2 = 46mm.
      // Gap: Pitch (55.333) - Width (46) = 9.333mm.
      // Top: "Shift 0.5 down" -> 5 + 0.5 = 5.5mm.
      
      labelWidth: 46,      // Increased by 2mm
      labelHeight: 17.8,   // Kept same
      marginTop: 5.5,      // Shifted down 0.5mm
      marginLeft: 1,       // Kept same (confirmed correct)
      horizontalGap: 9.333,// Recalculated for new width (was 11.333)
      verticalGap: 0,      // 0"
    },
    debug: {
      cornerRadius: 1.5 
    }
  },
  
  // Avery 5160 - Address Labels (Standard)
  // 3 columns x 10 rows = 30 labels
  '5160': {
    name: 'Avery 5160 (Address Label)',
    description: '30 labels per sheet (3 cols x 10 rows)',
    page: {
      width: 215.9,
      height: 279.4,
    },
    layout: {
      rows: 10,
      cols: 3,
    },
    dimensions: {
      labelWidth: 66.675,  // 2.625"
      labelHeight: 25.4,   // 1.0"
      marginTop: 12.7,     // 0.5"
      marginLeft: 4.7625,  // 0.1875"
      horizontalGap: 3.175,// 0.125"
      verticalGap: 0,      // 0"
    }
  }
};
